import {withHandlers} from 'recompose'

import compose from 'lodash/flowRight'
import type {ConnectedProps} from 'react-redux'
import {connect} from 'react-redux'

import {openDialog as openDialogAction} from '../../../../actions'
import type {State} from '../../../../reducers/types'
import {getBuild, isBuildLoaded} from '../../../../selectors'
import {DialogType, stringifyId} from '../../../../types'
import type {BuildTypeId, BuildId, NormalizedBuild} from '../../../../types'

import CompareBuildsHeader from './CompareBuildsHeader'

type OwnProps = {
  sourceId: BuildId
  compareWithId: BuildId | null | undefined
}
type StateProps = {
  hasAnyBranch: boolean
  sourceBuildLoaded: boolean
  sourceBuildStarted: string | null | undefined
  sourceBuildFinished: string | null | undefined
  sourceBuildNumber: string | null | undefined
  sourceHasAgent: boolean
  sourceBuildTypeId: BuildTypeId | null | undefined
  compareBuildLoaded: boolean
  compareBuildStarted: string | null | undefined
  compareBuildFinished: string | null | undefined
  compareBuildNumber: string | null | undefined
  compareHasAgent: boolean
  compareBuildTypeId: BuildTypeId | null | undefined
}

const mapStateToProps = (state: State, {sourceId, compareWithId}: OwnProps): StateProps => {
  const sourceBuild: Partial<NormalizedBuild> = getBuild(state, sourceId) || {}
  const compareBuild: Partial<NormalizedBuild> = getBuild(state, compareWithId) || {}
  return {
    hasAnyBranch: sourceBuild.branchName != null || compareBuild.branchName != null,
    sourceBuildLoaded: isBuildLoaded(state, sourceId),
    compareBuildLoaded: isBuildLoaded(state, compareWithId),
    sourceBuildStarted: sourceBuild.startDate,
    sourceBuildFinished: sourceBuild.finishDate,
    sourceBuildNumber: sourceBuild.number,
    sourceHasAgent: sourceBuild.agent != null,
    sourceBuildTypeId: sourceBuild.buildType,
    compareBuildStarted: compareBuild.startDate,
    compareBuildFinished: compareBuild.finishDate,
    compareBuildNumber: compareBuild.number,
    compareHasAgent: compareBuild.agent != null,
    compareBuildTypeId: compareBuild.buildType,
  }
}

const actionCreators = {
  openDialog: openDialogAction,
}
const connector = connect(mapStateToProps, actionCreators)

export default compose(
  connector,
  withHandlers({
    onCompareClick:
      ({sourceId, openDialog}: OwnProps & ConnectedProps<typeof connector>) =>
      () =>
        openDialog(stringifyId(sourceId), DialogType.COMPARE),
    onSourceClick:
      ({compareWithId, openDialog}) =>
      () => {
        if (compareWithId) {
          openDialog(stringifyId(compareWithId), DialogType.COMPARE)
        }
      },
  }),
)(CompareBuildsHeader)
